module.exports = __webpack_public_path__ + "static/media/01.dc47dba7.jpg";